import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { CreatePaymentInput, ModelType, PaymentType } from "@/gql/graphql";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { createSupplierPaymentValidation } from "@/app/Payments/Validators/createSupplierPaymentValidation";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { PaymentForm } from "@/app/Payments/Forms/PaymentForm";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createPaymentMutation } from "@/app/Payments/GraphQL/paymentMutations";
import { BookingRecord } from "@/app/Bookings/GraphQL/bookingRecordQuery";
import dayjs from "dayjs";

type BookingPaymentCreateDialogProps = {
  booking: BookingRecord;
  initialValues?: Partial<CreatePaymentInput>;
};
export function BookingPaymentCreateDialog({
  booking,
  initialValues,
}: BookingPaymentCreateDialogProps) {
  const { mutateAsync } = useGqlMutation(createPaymentMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog title={"Add supplier payment"}>
      <GenericForm<CreatePaymentInput>
        validationSchema={toFormikValidationSchema(
          createSupplierPaymentValidation,
        )}
        initialValues={{
          type: PaymentType.SupplierPayment,
          amount: null!,
          attributedTo: {
            connect: {
              type: ModelType.Booking,
              id: booking.id,
            },
          },

          due_date: dayjs(booking.deliver_at).format("YYYY-MM-DD"),

          payee: {
            connect:
              booking.deliveryOffice?.billingEntity?.id ??
              booking.supplier.billingEntity?.id ??
              null,
          },
          description: "",
          currency: booking.supplier.billing_currency,
          is_tax_included: booking.supplier.is_tax_included,
          tax_type: booking.supplier.tax_type,
          ...initialValues,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            input: values,
          });

          await close();
        }}
      >
        <PaymentForm manager={booking.supplier.managedBy ?? undefined} />
        <DialogSubmitButton text={"Add payment"} />
      </GenericForm>
    </BaseDialog>
  );
}
